// extracted by mini-css-extract-plugin
export default {"root":"Taxes_root__x5FuB"};